<template>
    <v-app-bar v-if="isAuthed" :height="heightComputed" fixed class="navbar navbarbg" app light flat :class="{'status-overlay-navbar': statusBarOverlay, scrolled: isScrolled, welcome: $route.name === 'welcome'}">
        <div class="w-100" :class="{'fill-height': !statusBarOverlay, 'd-flex flex-column': statusBarOverlay}">
            <div v-if="statusBarOverlay" class="status-overlay px-3 d-flex flex-row-reverse align-center surface w-100" style="height: 38px">
                <template v-if="!isProduction">
                    <v-spacer></v-spacer>
                    <v-icon small class="ms-1">mdi-wifi-strength-4</v-icon>
                    <v-icon small class="ms-1">mdi-signal-cellular-outline</v-icon>
                    <v-icon small class="ms-1">mdi-battery</v-icon>
                    <span class="details-text me-1">12:30</span>
                </template>
            </div>
            <v-divider v-if="statusBarOverlay" class="mb-1"></v-divider>
            
            <v-container class="d-flex px-1 py-0 fill-height align-center flex-row-reverse" :class="{'px-1': !statusBarOverlay, 'px-4': statusBarOverlay}">
                <div class="d-flex align-center">
                    <template v-if="isAuthed">
                        <v-btn v-if="pcOnly" icon exact :color="subscription === 'premium' ? 'orange darken-2' : 'grey lighten-1'" :to="{name: 'bills'}">
                            <v-icon size="27">mdi-crown{{subscription === 'free' ? '-outline' : ''}}</v-icon>
                        </v-btn>

                        <inbox-button margin />
                        <notifications-menu />
                        <user-nav :name="user.name" :avatar="user.avatar" />
                    </template>
                    <div v-else-if="pcOnly">
                        <!-- <avatar :to="{name: 'login'}" :size="30" :icon-size="25"/> -->

                        <v-btn :to="{name: 'login'}" color="primary darken-1" depressed :text="$route.name !== 'login'">تسجيل الدخول</v-btn>
                        <!-- <v-btn :to="{name: 'register'}" color="primary darken-1" depressed :outlined="$route.name !== 'register'" class="ms-3">حساب جديد</v-btn> -->
                    </div>
                </div>
                
                <v-spacer />
                
                <div class="d-flex align-center">
                    <v-btn v-if="phoneOnly" large icon @click.prevent="$emit('menu')" class="me-1" style="margin-right: -10px">
                        <v-icon size="24">mdi-menu</v-icon>
                    </v-btn>
                    
                    <div class="d-flex align-center justify-center">
                        <!-- <logo :width="100" /> -->
                        <img :src="storeData.logo" style="max-width: 130px; max-height: 55px;" />
                    </div>
                </div>
            </v-container>
        </div>

        <transition name="fade-transition">
            <v-progress-linear v-if="linearLoading" :active="linearLoading" :indeterminate="linearLoading" absolute bottom color="secondary" height="2" ></v-progress-linear>
        </transition>

    </v-app-bar>
    <v-app-bar v-else :height="heightComputed" fixed class="navbar" app light flat :style="statusBarOverlay ? 'border: none!important' : ''">
        <div class="fill-height d-flex justify-center align-center w-100" :class="{'mt-6': statusBarOverlay}">
            <logo :width="110" />
        </div>
    </v-app-bar>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import NotificationsMenu from './notifications-menu'
import InboxButton from '@/views/Inbox/inbox-button'

// import Avatar from '../../default/avatar'
import UserNav from './user-nav'

export default {
    props: {
        height: {
            default: 60,
            type: Number
        }
    },
    data(){
        return {
            isScrolled: false,
        }
    },
    components: {
        NotificationsMenu,
        UserNav,
        InboxButton,
        // Avatar,
    },
    computed: {
        linearLoading(){
            return this.$store.state.globalModule.linearLoading;  
        },
        statusBarOverlay(){
            return this.platform === 'ios';
        },
        heightComputed(){
            let height = this.height;
            if (this.statusBarOverlay){
                height += 35;
            }
            return height;
        },
        ...GlobalComputed
    },
    methods: {
        handleScroll(event){
            if (window.scrollY === 0){
                this.isScrolled = false;
            }else if (!this.isScrolled){
                this.isScrolled = true;
            }
        },
        ...GlobalMethods
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss" scoped>
    .navbar{
        background-color: #fff!important;
        transition: all 0.2s ease!important;
        
        &.scrolled, &:not(.welcome){
            // box-shadow: 0 1px 4px 0 rgba(0,0,0, .1)!important;
            border-bottom: 1px solid rgba(#000, 0.1)!important;
        }
    }
</style>
<style lang="scss">
.status-overlay-navbar{
    .v-toolbar__content{
        padding: 0!important;
        align-items: start!important;
    }
}
</style>